var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.div_class,attrs:{"issuerId":_vm.issuer.id}},[_c('img',{attrs:{"src":_vm.issuer.image.size1x}}),_c('p',[_vm._v(_vm._s(_vm.issuer.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }